module.exports = __webpack_public_path__ + "static/media/ice-cream-03.1f72efe2.png";